import MainRouter from "./navigation/router";

function App() {
  return (
    <MainRouter />
  );
}

export default App;
